import React from 'react';
import { MessageSquare } from 'lucide-react';

interface CTASectionProps {
  onChatOpen: () => void;
}

export function CTASection({ onChatOpen }: CTASectionProps) {
  return (
    <section className="bg-white py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-8">
          Klaar om Uw Klantenservice te Vernieuwen?
        </h2>
        <p className="text-xl text-gray-600 mb-12">
          Sluit u aan bij duizenden bedrijven die onze AI-chatassistent gebruiken om uitzonderlijke klantervaringen te bieden.
        </p>
        <button 
          onClick={onChatOpen}
          className="bg-brand-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-brand-600 transition-colors inline-flex items-center gap-2 text-lg"
        >
          Start Gratis Proefperiode <MessageSquare size={24} />
        </button>
      </div>
    </section>
  );
}